import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { redirectTo } from 'frontend_core/dist/helpers/http'
import { setUIState } from 'redux/modules/ui'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { helpUrl, wwwUrl } from 'frontend_core/dist/helpers/url'
import Path from 'routes/path'
import { loginUrlWithQuery } from 'helpers/format'

function Container(props) {
  function renderLoggedIn() {
    return (
      <header>
        <div>
          <div className="site-header clearfix">
            <p className="fl">
              <a href={wwwUrl('/')} className="site-header__logo">
                {i18n.t('spacemarket')}
              </a>
            </p>
            <ul className="site-header__nav sm-hide">
              <li>
                <a
                  href={wwwUrl('/dashboard')}
                  className="site-header__nav-user"
                >
                  <img
                    src={props.currentUser.profileImage}
                    alt={props.currentUser.name}
                    className="site-header__nav-user-icon"
                  />
                  <p className="site-header__nav-user-name link-black link-borderless">
                    <i className="fa fa-caret-down" />
                  </p>
                </a>
              </li>
              <li>
                <a
                  href={helpUrl()}
                  className="site-header__nav-help link-black link-borderless"
                >
                  <span className="help__text">
                    {i18n.t('page.header.help')}
                  </span>
                </a>
              </li>
              {/* <li>
                <a href={wwwUrl('/referrals')} className="site-header__nav-help link-black link-borderless">
                  <span className="help__text">{i18n.t('page.header.inviteFriends')}</span>
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </header>
    )
  }

  function renderAnonymous() {
    return (
      <header>
        <div>
          <div className="site-header clearfix">
            <p className="fl">
              <a href={wwwUrl('/')} className="site-header__logo">
                {i18n.t('spacemarket')}
              </a>
            </p>
            <ul className="site-header__nav sm-hide">
              <li>
                <a href={Path.signUp()} className="site-header__nav-user">
                  <p className="site-header__nav-user-name link-black">
                    {i18n.t('page.header.registration')}
                  </p>
                </a>
              </li>
              <li>
                <a
                  href={loginUrlWithQuery(props.config.URL)}
                  className="site-header__nav-user"
                >
                  <p className="site-header__nav-user-name link-black">
                    {i18n.t('page.header.login')}
                  </p>
                </a>
              </li>
              <li>
                <a
                  href={helpUrl()}
                  className="site-header__nav-help link-black link-borderless"
                >
                  <span className="help__text">
                    {i18n.t('page.header.help')}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </header>
    )
  }

  if (!!props.currentUser) return renderLoggedIn()
  return renderAnonymous()
}

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Container)
